export default "__VITE_ASSET__CRLDXT7E__"